import { MenuItem, TextField } from "@mui/material";
import { ChangeEvent, useCallback } from "react";
import { FilterType, languages, statuses } from "../../utils/filters";
import { useBannersFilter } from "../../hooks/useBannersFilter";
import { useGetProductsQuery } from "src/api/services/productsApi";

interface FilterProps {
  current: FilterType;
}

const Filter = ({ current }: FilterProps) => {
  const [filter, setFilter] = useBannersFilter(current.name);
  const { products } = useGetProductsQuery(undefined, {
    selectFromResult: ({ data }) => {
      return { products: data?.data ?? [] };
    },
  });

  const handleOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setFilter(e.target.value);
    },
    [setFilter],
  );

  return (
    <TextField
      size="small"
      select
      label={current.placeholder}
      value={filter}
      onChange={handleOnChange}
      sx={{ width: "200px" }}
    >
      <MenuItem value="">All</MenuItem>
      {current.name === "status"
        ? statuses.map((s, idx) => (
            <MenuItem key={idx} value={s}>
              {s}
            </MenuItem>
          ))
        : current.name === "product"
          ? products?.map((p, idx) => (
              <MenuItem key={idx} value={p.id}>
                {p.name}
              </MenuItem>
            ))
          : languages.map((l) => (
              <MenuItem value={l} key={l}>
                {l}
              </MenuItem>
            ))}
    </TextField>
  );
};

export default Filter;
